import styled from 'styled-components';

const BlogStyle = styled.div`
	--firstContentPadding: var(--sp19x) var(--sp12x) var(--sp10x) var(--sp4x);
	--firstContentTitleMargin: var(--sp4x) 0 var(--sp3x) 0;
	--firstContentReadTime: var(--sp3x) 0 var(--sp2x) 0;
	--firstItemMarginBottom: var(--sp18x);
	--blogImageWidth: 49%;
	--blogImagePaddingTop: 81.9%;
	--selectedChildWidth: 42%;
	--selectedChildPaddingTop: 55.6%;
	--contentPadding: var(--sp2x);
	--blogItemMarginTop: var(--sp3x);
	--readTimeMarginTopBottom: var(--sp2x) 0 var(--sp1x) 0;
	--blogsContainerMarginTop: var(--sp8x);
	--bookmarkSizes: var(--sp9x);
	--itemsWrapMarginBottom: var(--sp8x);

	.blogs-container {
		margin-top: var(--blogsContainerMarginTop);

		.items-wrap {
			display: flex;
			flex-wrap: wrap;
			margin: 0 calc(var(--sp1-5x) * -1);
			margin-top: calc(var(--blogItemMarginTop) * -1);
			margin-bottom: var(--itemsWrapMarginBottom);

			.blog-item {
				position: relative;
				display: flex;
				flex-direction: column;
				align-items: center;
				width: calc((100% - var(--selectedChildWidth)) / 2);
				padding: 0 var(--sp1-5x);
				margin-top: var(--blogItemMarginTop);

				.bookmark {
					position: absolute;
					left: var(--sp3-5x);
					top: calc(var(--sp2x) * -1);
					z-index: 1;
					display: flex;
					justify-content: center;
					align-items: center;
					text-align: center;
					padding: var(--sp2x) var(--sp3x);
					min-width: var(--bookmarkSizes);
					max-width: var(--bookmarkSizes);
					height: var(--bookmarkSizes);
					background-color: var(--lightGreen);
					transform: translateY(100px);
					opacity: 0;
				}

				.blog-image {
					padding-top: var(--blogImagePaddingTop);
					transform: scale(0);
				}

				&:nth-child(3n + 2) {
					width: var(--selectedChildWidth);

					.blog-image {
						padding-top: var(--selectedChildPaddingTop);
					}
				}

				&.first {
					width: unset;
					flex-direction: row;
					margin-bottom: var(--firstItemMarginBottom);
					width: 100%;

					.bookmark {
						display: none;
					}

					.blog-image {
						padding-top: 52.1%;
						min-width: var(--blogImageWidth);
						max-width: var(--blogImageWidth);
					}

					.content {
						background-color: rgba(176, 227, 217, 0.1);
						padding: var(--firstContentPadding);
						height: fit-content;

						.title {
							margin: var(--firstContentTitleMargin);
						}

						.description {
							transform: translateY(100px);
							opacity: 0;
						}

						.read-time {
							align-items: center;
							margin: var(--firstContentReadTime);
						}
					}
				}

				.content {
					display: flex;
					flex-direction: column;
					width: 100%;
					height: 100%;
					padding: var(--contentPadding);
					background-color: var(--white);
					padding: var(--sp2x);
					overflow: hidden;

					.count {
						transform: translateY(100px);
						opacity: 0;
					}

					.title {
						transform: translateY(100px);
						opacity: 0;
					}

					.blog-title {
						margin-bottom: auto;
						transform: translateY(100px);
						opacity: 0;
					}

					.read-time {
						display: flex;
						margin: var(--readTimeMarginTopBottom);
						transform: translateY(100px);
						opacity: 0;

						.icon-time {
							margin-right: var(--sp1-5x);
						}
					}

					.author-explore-wrap {
						transform: translateY(100px);
						opacity: 0;
						display: flex;
						justify-content: space-between;
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--firstContentPadding: var(--sp18x) var(--sp8x) var(--sp6x) var(--sp3x);
		--firstContentTitleMargin: var(--sp4x) 0 var(--sp3x) 0;
		--firstItemMarginBottom: var(--sp15x);
		--blogItemMarginTop: var(--sp3x);
		--blogsContainerMarginTop: var(--sp8x);
		--itemsWrapMarginBottom: var(--sp6x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--firstContentPadding: var(--sp17x) var(--sp6x) var(--sp6x) var(--sp3x);
		--firstItemMarginBottom: var(--sp13x);
		--blogItemMarginTop: var(--sp3x);
		--blogsContainerMarginTop: var(--sp7x);
		--itemsWrapMarginBottom: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--firstContentPadding: var(--sp8x) var(--sp5x) var(--sp3x) var(--sp3x);
		--firstContentTitleMargin: var(--sp1x) 0 var(--sp2x) 0;
		--firstContentReadTime: var(--sp2x) 0 var(--sp1x) 0;
		--firstItemMarginBottom: var(--sp10x);
		--blogItemMarginTop: var(--sp3x);
		--blogsContainerMarginTop: var(--sp7x);
		--bookmarkSizes: var(--sp8x);
		--itemsWrapMarginBottom: var(--sp4x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--firstContentPadding: var(--sp4x) 0 var(--sp3x) var(--sp3x);
		--firstContentTitleMargin: var(--sp1x) 0 var(--sp2x) 0;
		--firstContentReadTime: var(--sp2x) 0 var(--sp1x) 0;
		--firstItemMarginBottom: var(--sp10x);
		--blogItemMarginTop: var(--sp3x);
		--selectedChildWidth: 100%;
		--blogsContainerMarginTop: var(--sp7x);
		--bookmarkSizes: var(--sp8x);
		--itemsWrapMarginBottom: var(--sp4x);

		.blogs-container {
			.items-wrap {
				.blog-item {
					width: 50%;

					&.first {
						.blog-image {
							padding-top: 72%;
						}
					}

					&.first {
						.content {
							background-color: transparent;
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--firstContentPadding: 0;
		--firstContentTitleMargin: var(--sp1x) 0 var(--sp2x) 0;
		--firstContentReadTime: var(--sp2x) 0 var(--sp1x) 0;
		--blogImageWidth: 100%;
		--firstItemMarginBottom: var(--sp4x);
		--blogItemMarginTop: var(--sp3x);
		--selectedChildWidth: 100%;
		--selectedChildPaddingTop: 100%;
		--blogsContainerMarginTop: var(--sp4x);
		--bookmarkSizes: var(--sp8x);
		--itemsWrapMarginBottom: var(--sp5x);

		.blogs-container {
			.items-wrap {
				.blog-item {
					flex-direction: column;
					width: 100%;

					.blog-image {
						padding-top: 100%;
					}

					&.first {
						flex-direction: column;

						.content {
							background-color: transparent;
						}

						.blog-image {
							margin-bottom: var(--sp4x);
							padding-top: 100%;
						}
					}
				}
			}
		}
	}
`;

export default BlogStyle;
